var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagicalWand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.071,
    height: 41.032,
    viewBox: "0 0 40.071 41.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(-1383.038 -979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sez5Hv",
    transform: "translate(-591.201 2843.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1978.869-1820.826a1.279,1.279,0,0,1-.9-.375c-1.112-1.112-2.228-2.219-3.333-3.337a1.219,1.219,0,0,1,.013-1.807c7.318-7.319,16.636-16.638,23.956-23.956a1.228,1.228,0,0,1,1.839-.011q1.651,1.639,3.29,3.29a1.228,1.228,0,0,1-.014,1.839c-7.323,7.324-16.647,16.647-23.969,23.972A1.272,1.272,0,0,1,1978.869-1820.826Zm22.28-25.272a1.141,1.141,0,0,0-.091-.119c-.472-.474-.948-.944-1.417-1.422-.1-.106-.168-.078-.257.013-.4.4-.8.8-1.194,1.2q-1.673,1.674-3.348,3.345c-.1.1-.164.174-.028.306.47.456.931.922,1.391,1.388.1.1.163.1.26,0q2.29-2.3,4.585-4.588C2001.084-1846.013,2001.112-1846.053,2001.149-1846.1Z",
    transform: "translate(0 -3.537)",
    fill: "#215c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M2101.818-1831.639c-.51.159-.959.3-1.408.438-1.123.345-2.246.694-3.372,1.028a.536.536,0,0,0-.4.412c-.448,1.495-.91,2.985-1.369,4.476-.024.079-.014.185-.131.221a.9.9,0,0,1-.178-.427c-.439-1.425-.879-2.85-1.306-4.279a.528.528,0,0,0-.4-.405c-1.486-.443-2.968-.9-4.449-1.357-.09-.028-.2-.029-.275-.135.074-.1.2-.109.3-.141,1.482-.454,2.964-.91,4.45-1.354a.522.522,0,0,0,.376-.4q.627-2.07,1.264-4.137c.06-.2.125-.39.188-.584.147.029.13.137.153.214.463,1.5.928,3,1.378,4.5a.559.559,0,0,0,.43.419c1.41.421,2.816.856,4.222,1.289A1.445,1.445,0,0,1,2101.818-1831.639Z",
    transform: "translate(-87.508 -25.557)",
    fill: "#215c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M2274.192-1864.394a5.514,5.514,0,0,1,.311.894c.166.517.328,1.036.476,1.559a.407.407,0,0,0,.313.31q1.094.324,2.183.665c.085.026.233.008.228.135,0,.1-.139.089-.219.114-.727.224-1.453.449-2.183.663a.433.433,0,0,0-.328.333c-.212.72-.439,1.436-.662,2.153-.026.083-.028.178-.123.246-.121-.056-.119-.188-.151-.29-.218-.7-.438-1.4-.638-2.1a.451.451,0,0,0-.352-.345c-.711-.208-1.418-.428-2.125-.65-.094-.03-.258-.013-.255-.145,0-.1.155-.094.245-.122.707-.221,1.413-.445,2.125-.651a.482.482,0,0,0,.367-.37c.2-.683.413-1.361.623-2.04A.776.776,0,0,1,2274.192-1864.394Z",
    transform: "translate(-278.849)",
    fill: "#215c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M2533.659-1597.277a1.012,1.012,0,0,1-.16-.4c-.208-.669-.418-1.339-.613-2.012a.452.452,0,0,0-.354-.344c-.7-.2-1.4-.422-2.1-.639-.1-.031-.216-.036-.278-.141.059-.11.169-.106.26-.135.707-.221,1.413-.445,2.124-.651a.455.455,0,0,0,.351-.347c.212-.73.438-1.457.664-2.183.024-.077.011-.211.123-.207s.094.136.119.214c.222.717.444,1.434.653,2.155a.476.476,0,0,0,.366.371c.712.2,1.417.43,2.124.651.089.028.2.02.251.131-.054.106-.165.1-.255.13-.688.214-1.377.43-2.069.631a.524.524,0,0,0-.415.4c-.2.713-.428,1.418-.649,2.125C2533.777-1597.445,2533.785-1597.332,2533.659-1597.277Z",
    transform: "translate(-522.952 -244.635)",
    fill: "#215c75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    transform: "translate(1384 981)",
    fill: "#f22e6c",
    stroke: "#215c75",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 10,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M7478.8,10224.945l4.289-4.676,4.289,4.676",
    transform: "translate(11639.693 -6468.754) rotate(90)",
    fill: "none",
    stroke: "#215c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicalWand);
export default __webpack_public_path__ + "static/media/magical-wand.08bc9eab2f393eef86822bd2180692d0.svg";
export { ForwardRef as ReactComponent };